/**
 * Text used in step one of schedule D.
 */
export const ScheduleDStepOneHelperMessages = {
    actionCodeTooltip: `This item must be completed. It indicates the action the Applicant wants the FCC to take on the specified location. Enter ‘A’ for Add, ‘M’ for Modify, or ‘D’ for Delete.`,

    locationNumberTooltip: `This item must be completed. If the station location has been previously licensed under this call sign by the FCC, enter its FCC-assigned location number (see Important Information Regarding Location, Antenna, and Control Point Numbers). For a new station location, assign a temporary code to represent the station location. The assigned code should begin with ‘L’ to indicate it is a location and end with a number to uniquely identify it (e.g., L1, L2, L3, etc.). The FCC will assign an official number to the new station, which will appear on the Authorization.`,

    locationDescriptionTooltip: `Enter the appropriate location description for the specified location. Valid location description codes are listed below:

      F - Fixed
      M - Mobile
      I - Itinerant
      T - Temporary Fixed
      6 - 6.1 Meter Control Station

      <b>NOTE</b>: For ‘IQ’ radio service only, leave item 3 blank as the Location Description is not required.`,

    locationNameTooltip:
        'This item is optional. Enter a location name that describes the location (up to 20 characters maximum).',

    areaOfOperationCodeTooltip: `Does not apply if Item 3 equals F. For Mobile, Temporary Fixed, Itinerant, and 6.1 Meter Control Stations, enter the appropriate area of operation code using the table that follows. This dropdown also includes Additional Schedule D fields must be completed according to the area of operation code chosen. Refer to the table to determine which additional fields are required on Schedule D for the chosen area of operation code. Only one area of operation code may be selected for each location.

      <b>Note</b>: If area of operation will cover multiple counties/boroughs/parishes, use area of operation code 'O' and in Item 24, specify all applicable counties/boroughs/parishes in and the state(s) the counties/boroughs/parishes are located in.

      <b>Area of Operation Codes and Required Data Values</b>
      <table class="text-sm text-tertiary-700 divide-y divide-tertiary-200">
        <thead>
        <tr>
          <th scope="col" class="text-start font-normal">Code Description</th>
          <th scope="col" class="text-start font-normal">Additional Schedule D Data Elements Required for each Area of Operation Code</th>
          <th scope="col" class="text-start font-normal">Item Numbers</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-tertiary-200">
        <tr>
          <td>A - KMRA* around a Fixed location
      (option not available to Maritime or Aviation
      Services)</td>
          <td>Fixed Location Number, Temporary Fixed or Mobile Radius </td>
          <td>17, 18</td>
        </tr>
        <tr>
          <td>P - KMRA* around a Center point</td>
          <td>Latitude, Longitude, City**, State, County/Borough/Parish**, Temporary Fixed or
      Mobile Radius</td>
          <td>7, 8, 10, 11, 12, 18</td>
        </tr>
        <tr>
          <td>R - Rectangular Area of Operation</td>
          <td>Latitude, Longitude, Maximum Latitude, Maximum Longitude</td>
          <td>7, 8, 21, 22</td>
        </tr>
        <tr>
          <td>N - Nationwide including Hawaii Alaska & US Territories</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>U - Continental US </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>C - County/Borough/Parish Wide Area of Operation</td>
          <td>State, County/Borough/Parish</td>
          <td>11, 12</td>
        </tr>
        <tr>
          <td>S - Statewide Area of Operation</td>
          <td>State</td>
          <td>11</td>
        </tr>
        <tr>
          <td>O - Other</td>
          <td>Description (should include State)</td>
          <td>24</td>
        </tr>
        <tr>
          <td>X - Land Mobile Control Station Meeting the 6.1 Meter Rule</td>
          <td>State, County/Borough/Parish</td>
          <td>11, 12</td>
        </tr>
        </tbody>
      </table>
      * Kilometers Radius
      ** Complete as applicable - refer to instructions for applicability
      `,

    towerRegistrationNumberTooltip: `If an FCC Antenna Structure Registration is required, enter the seven-digit ASR number (shown on the FCC Form 854R) or the ASR pending file number.  Otherwise, leave the field empty to indicate that an ASR is not required.

<b>NOTE</b>: Effective 7/1/96 the Commission requires owners to register certain structures. When required, antenna structures must be registered using FCC 854. The use of this FCC 601 to supply antenna structure information does not replace the requirement to register antenna structures on the FCC 854. For more information, see our web site at http://wireless.fcc.gov/antenna, call (877) 480-3201 (TTY 717-338-2824), or you may visit the web at http://esupport.fcc.gov.

<b>NOTE</b>: If, in accordance with 47 CFR § 17.14, Antenna Structure Registration is not required because the structure is shielded by existing structures or because it is fixed by its functional purpose, submit supporting documentation as an attachment to your application.`,

    requireEWAToRegisterTowerTooltip: `If you have determined that this site must be registered with the FCC and/or FAA, EWA can help. Would you like EWA to register this site with the FCC and/or FAA?`,
};
